export const FETCH_USERS_REQUEST = "FETCH_USERS_REQUEST";
export const FETCH_USERS_ERROR = "FETCH_USERS_ERROR";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";

export const FETCH_USER_BY_ID_REQUEST = "FETCH_USER_BY_ID_REQUEST";
export const FETCH_USER_BY_ID_ERROR = "FETCH_USER_BY_ID_ERROR";
export const FETCH_USER_BY_ID_SUCCESS = "FETCH_USER_BY_ID_SUCCESS";
export const FETCH_USER_BY_ID_RESET = "FETCH_USER_BY_ID_RESET";

export const DELETE_SONG_FROM_ALL_USERS_REQUEST =
  "DELETE_SONG_FROM_ALL_USERS_REQUEST";
export const DELETE_SONG_FROM_ALL_USERS_SUCCESS =
  "DELETE_SONG_FROM_ALL_USERS_SUCCESS";
export const DELETE_SONG_FROM_ALL_USERS_ERROR =
  "DELETE_SONG_FROM_ALL_USERS_ERROR";

export const DELETE_PLAYLIST_FROM_ALL_USERS_REQUEST =
  "DELETE_PLAYLIST_FROM_ALL_USERS_REQUEST";
export const DELETE_PLAYLIST_FROM_ALL_USERS_SUCCESS =
  "DELETE_PLAYLIST_FROM_ALL_USERS_SUCCESS";
export const DELETE_PLAYLIST_FROM_ALL_USERS_ERROR =
  "DELETE_PLAYLIST_FROM_ALL_USERS_ERROR";

export const RESET_STORE_AND_LOG_OUT = "RESET_STORE_AND_LOG_OUT";

export const userTypes = {
  ALL_USERS: "ALL_USERS",
  FOLLOWERS: "FOLLOWERS",
  FOLLOWING: "FOLLOWING",
  RECOMMENDED: "RECOMMENDED",
  POPULAR: "POPULAR",
};
